<template>
	<div class="counter-card">
		<p :class="titleClass">{{ title }}</p>
		<button v-if="icon" class="counter-card__refresh" :disabled="actionDisabled" @click="emit('expand')">
			<span class="material-symbols-outlined">{{ icon }}</span>
		</button>
		<p class="counter-card__value">{{ value }}</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
	title: string;
	value: number | '-';
	icon?: string;
	actionDisabled?: boolean;
}>();

const emit = defineEmits<{
	(e: string): void;
}>();

const titleClass = computed(() => (props.icon ? 'counter-card__title' : 'counter-card__title counter-card__title-wide'));
</script>

<style scoped>
.counter-card {
	width: 185px;
	height: 90px;
	display: grid;
	grid-template-columns: auto auto;
	grid-template-rows: auto auto;
	background-color: #4b525a;
	border-radius: 7.5px;
	padding: 5px 10px;
}

p {
	color: aliceblue;
	font-family: 'Fira Sans';
}

.counter-card__title-wide {
	grid-column: span 2;
	align-self: center;
}

.counter-card__title {
	align-self: center;
}

.counter-card__value {
	margin-left: 10px;
	margin-bottom: 0;
	align-self: flex-end;
	font-size: 2rem;
}

button {
	margin: 0;
	padding: 0;
	background-color: transparent;
	border: none;
	height: auto;
	width: auto;
	justify-self: flex-end;
	align-self: flex-end;
	margin-right: 10px;
}

button:hover {
	opacity: 75%;
	cursor: pointer;
	background: transparent;
}

button:disabled {
	opacity: 40%;
	cursor: default;
}

.material-symbols-outlined {
	font-size: 20px;
}
</style>
